import { ReportComponent as AipbReportComponent } from '@aipb/gulliver/report/feature';
import { HoverHighlightDirective } from '@aipb/shared/ui/directives';
import { InsideLoadingComponent, LoadingComponent } from '@aipb/shared/ui/loading';
import { UiOpenLayersModule } from '@aipb/shared/ui/open-layers';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatChipsModule } from '@angular/material/chips';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { MatTabsModule } from '@angular/material/tabs';
import { TranslocoModule } from '@jsverse/transloco';
import { CropFormComponent } from './components/crop-form/crop-form.component';
import { CropComponent } from './components/crop/crop.component';
import { DownloadComponent } from './components/download/download.component';
import { HeaderComponent } from './components/header/header.component';
import { ImagePreviewComponent } from './components/image-preview/image-preview.component';
import { ImageStripComponent } from './components/image-strip/image-strip.component';
import { LicenseComponent } from './components/license/license.component';
import { OpenLayersComponent } from './components/open-layers/open-layers.component';
import { ReportComponent } from './components/report/report.component';
import { MtxButtonModule } from '@ng-matero/extensions/button';
import { MatIconModule } from '@angular/material/icon';

@NgModule({
  imports: [
    CommonModule,
    MatTabsModule,
    MatChipsModule,
    TranslocoModule,
    UiOpenLayersModule,
    ScrollingModule,
    InsideLoadingComponent,
    MatFormFieldModule,
    MatSelectModule,
    FormsModule,
    ReactiveFormsModule,
    AipbReportComponent,
    MatButtonModule,
    HoverHighlightDirective,
    MtxButtonModule,
    MatIconModule,
    LoadingComponent
  ],
  declarations: [
    ImagePreviewComponent,
    ImageStripComponent,
    OpenLayersComponent,
    CropComponent,
    CropFormComponent,
    DownloadComponent,
    LicenseComponent,
    HeaderComponent,
    ReportComponent
  ],
  exports: [ImagePreviewComponent]
})
export class GulliverImagePreviewModule {}
